const TECHNOLOGIES = new Set(['browser', 'windows', 'sap']);

/** Label-Schluessel der Technologie einer Engine; unbekannte Engines aus dem Bestand zeigt das Badge roh. */
export function technologyKey(engineId: string): string | null {
  return TECHNOLOGIES.has(engineId) ? `objectMappings.technology.${engineId}` : null;
}
